import * as React from 'react';
import moment from 'moment';

import { TYPE_FILTER_MAP } from 'components/FroalaTaggedInput';
import { TEMPLATE_TAG_LABELS } from 'utils';
import { PropertyAnnouncementType } from './types';

interface OfferMessageBoxProps {
  propertyAnnouncement: PropertyAnnouncementType;
  onClick: (id: string) => void;
  isActive: boolean;
}

const OfferMessageBox = (props: OfferMessageBoxProps) => {
  const { onClick, propertyAnnouncement, isActive } = props;
  const { id, subject, body, createdAt } = propertyAnnouncement;

  const replaceHtmlTags = (value: string) => {
    const htmlTagRegex = /<[^>]*>/g;
    const noHtmlTagString = value.replace(htmlTagRegex, ' ');
    return noHtmlTagString;
  };

  const replaceFroalaTags = (value: string) => TYPE_FILTER_MAP.propertyAnnouncement.reduce((acc, cur) => acc.replace(
        new RegExp(`{{${cur}}}`, 'gi'),
        TEMPLATE_TAG_LABELS[cur],
      ), value);

  const parseHtml = (value: string) => replaceFroalaTags(replaceHtmlTags(value));

  let boxClassName = 'offer-message-box';
  if (isActive) {
    boxClassName += ' offer-message-box-active';
  }

  return (
    <div className={boxClassName} onClick={() => onClick(id)}>
      <div className="row">
        <div className="col-md-12">
          <div className="flex-container" style={{ flexWrap: 'nowrap' }}>
            <div style={{ width: '60%' }}>
              <h5 className="text-ellipsis">{subject}</h5>
            </div>
            <div>{moment(createdAt).format('MMM D, YYYY h:mm:ss A')}</div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-md-12">
          <p className="text-ellipsis">{parseHtml(body)}</p>
        </div>
      </div>
    </div>
  );
};

export default OfferMessageBox;
